<template>
  <div class="comp-ly-list-layout">
    <template v-if="!skeletonLoading">
      <div v-show="selectTableIds?.length" class="list-batch-wrap">
        <ly-list-batch-buttons v-show="selectTableIds?.length" :listFields="data.fieldList" :entityId="entity" :filterParams="filterParams" :buttonShortcut="buttonShortcut" :fieldsListAll="buttonBatch" @cb="resetSelected" :selectIds="selectTableIds" :bingDataList="bingDataList" :viewId="data.viewId"></ly-list-batch-buttons>
      </div>
      <div v-show="!selectTableIds?.length" class="filter-wrap-layout">
        <ly-list-universal-buttons :entityId="entity" :universalButtonParams="universalButtonParams" ref="lyListUniversalButtonsRef" @cb="universalRefreshList"></ly-list-universal-buttons>

        <jw-space class="title-split" v-if="props.isFilter">
          <!-- <ly-advanced-filter v-if="isShowFilter" :key="data.viewId" :fieldList="data.fieldList" :fieldGroups="fieldGroups" @cb="getSearchData"></ly-advanced-filter> -->
          <ly-advanced-filter v-if="isShowFilter" :entity="entity" :viewId="data.viewId" :key="data.viewId" :dropdownFieldList="fieldFilterList" :fieldList="data.fieldList" :fieldGroups="fieldGroups" :dataPermission="data.dataPermission" :commonList="highConditionsList" @cb="getSearchData" :newConditionCount="data.ruleForm.conditions?.length" @cbGroup="hasGroup" @cbSort="sortChange"></ly-advanced-filter>
          <span>
            <jw-tooltip :content="$t('列设置')">
              <span class="icon-bg-color hand" @click="openColSelect">
                <qf-icon-column-setting />
              </span>
            </jw-tooltip>
          </span>
          <span>
            <jw-tooltip content="刷新">
              <span class="icon-bg-color hand" @click="refreshList()" :class="[refreshLoading ? 'refresh-loading' : '']">
                <icon-refresh size="16" />
              </span>
            </jw-tooltip>
          </span>
        </jw-space>
      </div>
      <div>
        <div v-if="data.viewId && data.columns?.length" :style="dynamicStyle" @click="checkboxCk">
          <template v-if="data.idsAll.length">
            <t-checkbox :model-value="data.checkedDataAll" :indeterminate="data.indeterminate" @change="setCheckedAlls"> </t-checkbox>
          </template>
          <template v-else>
            <jw-tooltip content="请展开分组，核对数据后，再批量勾选" position="top">
              <t-checkbox disabled :model-value="data.checkedDataAll" :indeterminate="data.indeterminate"> </t-checkbox>
            </jw-tooltip>
          </template>
        </div>
        <fh-table v-if="data.viewId && data.columns?.length" id="targetElement" ref="fhOutTableRef" class="fhTable out-table" :isGroupTop="'top'" :viewId="data.viewId" row-key="id" :columns="com2" :on-scroll="(event) => handleScroll(event, 'top')" v-model:selectedRowKeys="selectTableIds" lazy-load :scroll="{ type: 'virtual', threshold: data.groupPageSize, rowHeight: 48, bufferSize: 10 }" :loading="groupStructureLoading" @cbGroup="cbGroup" resizable :max-height="listScroll">
          <template #empty>
            <div v-if="!arrLL.group?.length" class="fh-table-spin">
              <template v-if="groupStructureLoading">
                <ly-skeleton :tableColumns="data.columns" fromType="table" :lineHeight="22" :row="5"></ly-skeleton>
              </template>
              <template v-else>
                <jw-empty></jw-empty>
              </template>
            </div>
            <t-list v-else style="width: 100%; margin-top: 8px; overflow-x: hidden" :virtualListProps="{ height: 100, threshold: 40 }" class="first-table-inner">
              <t-list-item class="fh-table" v-for="(item, index) in arrLL.group" :key="index">
                <div class="group-content" style="margin-bottom: 8px">
                  <!-- 第一层 -->
                  <t-space class="group-content-title">
                    <icon-right class="hand" v-if="!item.isShow" @click="switchIsShow(item)" />
                    <icon-down class="hand" v-else @click="switchIsShow(item)" />
                    <template v-if="item.ids?.length">
                      <t-checkbox style="padding-top: 5px" :model-value="item.checkedAll" :indeterminate="item.indeterminate" @change="setCheckedGroupAll(item)"> </t-checkbox>
                    </template>

                    <template v-if="item.isShow">
                      <t-checkbox style="padding-top: 5px" v-show="!item.ids?.length" disabled> </t-checkbox>
                    </template>
                    <template v-else>
                      <jw-tooltip content="请展开分组，核对数据后，再批量勾选" position="top">
                        <t-checkbox style="padding-top: 5px" v-show="!item.ids?.length" disabled> </t-checkbox>
                      </jw-tooltip>
                    </template>

                    <div>
                      <jw-tag :color="item.bgcolor" :style="{ color: item.textcolor ? item.textcolor : 'black' }">{{ item?.label || '空值' }}</jw-tag>
                    </div>
                    <div>共{{ item.count }}条</div>
                  </t-space>
                  <template v-if="item.isShow || arrLL[item.groupKey]?.data">
                    <div v-show="item.isShow">
                      <div v-if="item.groups?.length" class="group-content group-content-2">
                        <div v-for="(subItem, subIndex) in item.groups" :key="subIndex">
                          <!-- 第二层 -->
                          <t-space class="group-content-title">
                            <icon-right class="hand" v-if="!subItem.isShow" @click="switchIsShow(subItem)" />
                            <icon-down class="hand" v-else @click="switchIsShow(subItem)" />
                            <template v-if="subItem.ids?.length">
                              <t-checkbox style="padding-top: 5px" :model-value="subItem.checkedAll" :indeterminate="subItem.indeterminate" @change="setCheckedGroupAll(subItem)"> </t-checkbox>
                            </template>

                            <template v-if="subItem.isShow">
                              <t-checkbox style="padding-top: 5px" v-show="!subItem.ids?.length" disabled> </t-checkbox>
                            </template>
                            <template v-else>
                              <jw-tooltip content="请展开分组，核对数据后，再批量勾选" position="top">
                                <t-checkbox style="padding-top: 5px" v-show="!subItem.ids?.length" disabled> </t-checkbox>
                              </jw-tooltip>
                            </template>

                            <div>
                              <jw-tag :color="subItem.bgcolor" :style="{ color: subItem.textcolor ? subItem.textcolor : 'black' }">{{ subItem?.label || '空值' }}</jw-tag>
                            </div>
                            <div>共{{ subItem.count }}条</div>
                          </t-space>
                          <template v-if="subItem.isShow || arrLL[subItem.groupKey]?.data">
                            <div v-show="subItem.isShow">
                              <div v-if="subItem.groups?.length" class="group-content group-content-3">
                                <div v-for="(thirdItem, thirdIndex) in subItem.groups" :key="thirdIndex">
                                  <!-- 第三层 -->
                                  <t-space class="group-content-title" style="padding-left: 8px">
                                    <icon-right class="hand" v-if="!thirdItem.isShow" @click="switchIsShow(thirdItem)" />
                                    <icon-down class="hand" v-else @click="switchIsShow(thirdItem)" />
                                    <div>
                                      <t-checkbox style="padding-top: 5px" :indeterminate="thirdItem.indeterminate" v-show="thirdItem.ids?.length" :model-value="thirdItem.checkedAll" @change="setCheckedGroupAll(thirdItem)"> </t-checkbox>
                                      <template v-if="thirdItem.isShow">
                                        <t-checkbox style="padding-top: 5px" v-show="!thirdItem.ids?.length" disabled> </t-checkbox>
                                      </template>
                                      <template v-else>
                                        <jw-tooltip content="请展开分组，核对数据后，再批量勾选" position="top">
                                          <t-checkbox style="padding-top: 5px" v-show="!thirdItem.ids?.length" disabled> </t-checkbox>
                                        </jw-tooltip>
                                      </template>
                                    </div>
                                    <div>
                                      <jw-tag :data-name="item.value + subItem.value + thirdItem.value" :data-groupKey="thirdItem.groupKey" :color="thirdItem.bgcolor" :style="{ color: thirdItem.textcolor ? thirdItem.textcolor : 'black' }">{{ thirdItem?.label || '空值' }}</jw-tag>
                                    </div>
                                    <div>共{{ thirdItem.count }}条</div>
                                  </t-space>
                                  <template v-if="thirdItem.isShow || arrLL[thirdItem.groupKey]?.data">
                                    <div class="group-tag" v-show="thirdItem.isShow" :data-name="item.value + subItem.value + thirdItem.value" :data-groupKey="thirdItem.groupKey" :style="{ minHeight: arrLL[thirdItem.groupKey]?.data?.length ? '0px' : '30px' }">
                                      <fh-table v-if="data.viewId" class="childrenTable children-Table-3" :refGroupKey="thirdItem.groupKey" ref="fhTableRef" @cb="cbGroup" v-model:groupKey="thirdItem.groupKey" :viewId="data.viewId" :isGroupTop="thirdItem.fieldKey" :on-scroll="(event) => handleScroll(event, thirdItem)" :bordered="false" :randomKey="randomKey" v-on="tPropsEvent" v-bind="arrLL[thirdItem.groupKey]" :active-row-type="data.activeRow ? 'single' : undefined" row-key="id" v-model:selectedRowKeys="selectTableIds" @select-change="fhTableSelect" size="medium" :columns="data.columns" lazy-load hover :key="resizeRandom" :scroll="{ type: 'virtual', threshold: data.groupPageSize, rowHeight: 48, bufferSize: 10 }" resizable @cbGroup="cbGroup" :onRowClick="rowGroup1Click" :onChange="fhTablePagination" :activeRowKeys="activeGroup1RowKeys">
                                        <template #empty>
                                          <template v-if="thirdItem.loading">
                                            <ly-skeleton :tableColumns="data.columns" fromType="table" :lineHeight="22" :row="thirdItem.count > 20 ? 20 : thirdItem.count"></ly-skeleton>
                                          </template>
                                          <template v-else>
                                            <div class="fh-table-spin">
                                              <jw-empty></jw-empty>
                                            </div>
                                          </template>
                                        </template>
                                        <!-- 操作按钮部分S -->
                                        <template #operations="{ row }">
                                          <div class="operation-button" v-if="buttonShortcut?.length && row.LOGIC_ROLE_PERMISSION && row.LOGIC_ROLE_PERMISSION == 1" @click.stop="">
                                            <ly-list-shortcut-buttons :viewId="data.viewId" :entityId="entity" :fieldsListAll="buttonShortcut" :recordObj="row" :groupKey="thirdItem.groupKey" ref="lyListShortcutRef" @cb="shortcutBtnCb"></ly-list-shortcut-buttons>
                                          </div>
                                          <div v-else>-</div>
                                        </template>

                                        <template #custom-operations-title>
                                          <div class="custom-operation-inner"><t-checkbox /></div>
                                        </template>

                                        <template #custom-operations="{ row }">
                                          <div class="custom-operation-inner" @click.stop="">
                                            <template v-if="computingStatus.includes(row?.computedInfo?.status)">
                                              <jw-tooltip content="公式计算中，计算成功后触发后续操作">
                                                <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin />
                                              </jw-tooltip>
                                            </template>
                                            <template v-if="row?.computedInfo?.status == 2">
                                              <ly-computed-icon-tips :computedInfo="row?.computedInfo" :hasChild="expandLevel1Icon" />
                                            </template>
                                            <template v-if="buttonBatch.length && !computingStatus.includes(row?.computedInfo?.status)">
                                              <t-checkbox @click.prevent="fhTableSelect(row.id, $event)" :checked="selectTableIds.includes(row.id)" />
                                            </template>
                                          </div>
                                        </template>

                                        <!-- 操作按钮部分E -->
                                        <!-- 每个对象的主属性字段 -->
                                        <template #[detailKey(entity)]="{ row }">
                                          <ly-template-slot :row="row" :detailKey="detailKey(entity)" :entity="entity" @cb="toDetails" />
                                        </template>
                                      </fh-table>
                                      <div class="loading-more" v-if="arrLL[thirdItem.groupKey]?.data?.length < thirdItem.count && thirdItem.count > 0" @click="getMore(thirdItem)">
                                        <div v-if="!thirdItem.loadingMore"><icon-double-down />加载更多</div>
                                        <t-loading text="加载中..." :loading="thirdItem.loadingMore" size="small"></t-loading>
                                      </div>
                                    </div>
                                  </template>
                                  <jw-divider v-if="subItem.groups?.length - 1 !== thirdIndex" :margin="8" style="margin-left: 40px" />
                                </div>
                              </div>
                              <div v-else>
                                <div v-show="subItem.isShow" class="group-tag" :data-name="item.value + subItem.value" :data-groupKey="subItem.groupKey" :style="{ minHeight: arrLL[subItem.groupKey]?.data?.length ? '0px' : '30px' }">
                                  <fh-table v-if="data.viewId" class="childrenTable children-Table-2" :bordered="false" :viewId="data.viewId" :randomKey="randomKey" :on-scroll="(event) => handleScroll(event, subItem)" v-on="tPropsEvent" v-bind="arrLL[subItem.groupKey]" :active-row-type="data.activeRow ? 'single' : undefined" row-key="id" v-model:selectedRowKeys="selectTableIds" @select-change="fhTableSelect" size="medium" ref="fhTableRef" :refGroupKey="subItem.groupKey" :columns="data.columns" lazy-load hover :key="resizeRandom" :scroll="{ type: 'virtual', threshold: data.groupPageSize, rowHeight: 48, bufferSize: 10 }" resizable :onRowClick="rowGroup2Click" @cbGroup="cbGroup" :onChange="fhTablePagination" :activeRowKeys="activeGroup2RowKeys">
                                    <template #empty>
                                      <template v-if="subItem.loading">
                                        <ly-skeleton :tableColumns="data.columns" fromType="table" :lineHeight="22" :row="subItem.count > 20 ? 20 : subItem.count"></ly-skeleton>
                                      </template>
                                      <template v-else>
                                        <div class="fh-table-spin">
                                          <jw-empty></jw-empty>
                                        </div>
                                      </template>
                                    </template>

                                    <template #custom-operations-title>
                                      <div class="custom-operation-inner"><t-checkbox /></div>
                                    </template>

                                    <template #custom-operations="{ row }">
                                      <div class="custom-operation-inner" @click.stop="">
                                        <template v-if="computingStatus.includes(row?.computedInfo?.status)">
                                          <jw-tooltip content="公式计算中，计算成功后触发后续操作">
                                            <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin />
                                          </jw-tooltip>
                                        </template>
                                        <template v-if="row?.computedInfo?.status == 2">
                                          <ly-computed-icon-tips :computedInfo="row?.computedInfo" :hasChild="expandLevel1Icon" />
                                        </template>
                                        <template v-if="buttonBatch.length && !computingStatus.includes(row?.computedInfo?.status)">
                                          <t-checkbox @click.prevent="fhTableSelect(row.id, $event)" :checked="selectTableIds.includes(row.id)" />
                                        </template>
                                      </div>
                                    </template>

                                    <!-- 操作按钮部分S -->
                                    <template #operations="{ row }">
                                      <div class="operation-button" v-if="buttonShortcut?.length && row.LOGIC_ROLE_PERMISSION && row.LOGIC_ROLE_PERMISSION == 1" @click.stop="">
                                        <ly-list-shortcut-buttons :viewId="data.viewId" :entityId="entity" :fieldsListAll="buttonShortcut" :recordObj="row" :groupKey="subItem.groupKey" ref="lyListShortcutRef" @cb="shortcutBtnCb"></ly-list-shortcut-buttons>
                                      </div>
                                      <div v-else>-</div>
                                    </template>
                                    <template v-for="(slot, slotName) in $slots" #[slotName]="slotProps" :key="slotName">
                                      <div @click.stop="">
                                        <slot :name="slotName" v-bind="slotProps" />
                                      </div>
                                    </template>
                                    <!-- 操作按钮部分E -->
                                    <!-- 每个对象的主属性字段 -->
                                    <template #[detailKey(entity)]="{ row }">
                                      <ly-template-slot :row="row" :detailKey="detailKey(entity)" :entity="entity" @cb="toDetails" />
                                    </template>
                                  </fh-table>
                                  <div class="loading-more" v-if="arrLL[subItem.groupKey]?.data?.length < subItem.count && subItem.count > 0" @click="getMore(subItem)">
                                    <div v-if="!subItem.loadingMore"><icon-double-down />加载更多</div>
                                    <t-loading text="加载中..." :loading="subItem.loadingMore" size="small"></t-loading>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <jw-divider v-if="item.groups?.length - 1 !== subIndex" :margin="8" style="margin-left: 30px" />
                        </div>
                      </div>
                      <div v-else>
                        <div v-show="item.isShow" class="group-tag" :data-name="item.value" :data-groupKey="item.groupKey" :style="{ minHeight: arrLL[item.groupKey]?.data?.length ? '0px' : '30px' }">
                          <fh-table v-if="data.viewId" class="childrenTable children-Table-1" :loading="item.loadingMore" :bordered="false" :viewId="data.viewId" :randomKey="randomKey" :on-scroll="(event) => handleScroll(event, item)" v-on="tPropsEvent" v-bind="arrLL[item.groupKey]" :active-row-type="data.activeRow ? 'single' : undefined" row-key="id" v-model:selectedRowKeys="selectTableIds" @select-change="fhTableSelect" size="medium" ref="fhTableRef" :refGroupKey="item.groupKey" :columns="data.columns" lazy-load hover :key="resizeRandom" :scroll="{ type: 'virtual', threshold: data.groupPageSize, rowHeight: 48, bufferSize: 10 }" resizable :onRowClick="rowGroup3Click" @cbGroup="cbGroup" :onChange="fhTablePagination" :activeRowKeys="activeGroup3RowKeys">
                            <template #empty>
                              <template v-if="item.loading">
                                <ly-skeleton :tableColumns="data.columns" fromType="table" :lineHeight="22" :row="item.count > 20 ? 20 : item.count"></ly-skeleton>
                              </template>
                              <template v-else>
                                <div class="fh-table-spin">
                                  <jw-empty></jw-empty>
                                </div>
                              </template>
                            </template>

                            <template #custom-operations-title>
                              <div class="custom-operation-inner"><t-checkbox /></div>
                            </template>

                            <template #custom-operations="{ row }">
                              <div class="custom-operation-inner" @click.stop="">
                                <template v-if="computingStatus.includes(row?.computedInfo?.status)">
                                  <jw-tooltip content="公式计算中，计算成功后触发后续操作">
                                    <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin />
                                  </jw-tooltip>
                                </template>
                                <template v-if="row?.computedInfo?.status == 2">
                                  <ly-computed-icon-tips :computedInfo="row?.computedInfo" :hasChild="expandLevel1Icon" />
                                </template>
                                <template v-if="buttonBatch.length && !computingStatus.includes(row?.computedInfo?.status)">
                                  <t-checkbox @click.prevent="fhTableSelect(row.id, $event)" :checked="selectTableIds.includes(row.id)" />
                                </template>
                              </div>
                            </template>

                            <!-- 操作按钮部分S -->
                            <template #operations="{ row }">
                              <div class="operation-button" v-if="buttonShortcut?.length && row.LOGIC_ROLE_PERMISSION && row.LOGIC_ROLE_PERMISSION == 1" @click.stop="">
                                <ly-list-shortcut-buttons :viewId="data.viewId" :entityId="entity" :fieldsListAll="buttonShortcut" :recordObj="row" :groupKey="item.groupKey" ref="lyListShortcutRef" @cb="shortcutBtnCb"></ly-list-shortcut-buttons>
                              </div>
                              <div v-else>-</div>
                            </template>
                            <template v-for="(slot, slotName) in $slots" #[slotName]="slotProps" :key="slotName">
                              <div @click.stop="">
                                <slot :name="slotName" v-bind="slotProps" />
                              </div>
                            </template>
                            <!-- 操作按钮部分E -->
                            <!-- 每个对象的主属性字段 -->
                            <template #[detailKey(entity)]="{ row }">
                              <ly-template-slot :row="row" :detailKey="detailKey(entity)" :entity="entity" @cb="toDetails" />
                            </template>
                          </fh-table>
                          <div class="loading-more" v-if="arrLL[item.groupKey]?.data?.length < item.count && item.count > 0" @click="getMore(item)">
                            <div v-if="!item.loadingMore"><icon-double-down />加载更多</div>
                            <t-loading text="加载中..." :loading="item.loadingMore" size="small"></t-loading>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </t-list-item>
            </t-list>
          </template>
          <template #custom-operations-title>
            <div class="custom-operation-inner"></div>
          </template>
        </fh-table>
        <div v-if="arrLL.group?.length" class="one-touch">
          <div @click="oneTouchRetract" :disabled="checkAllExpand" :class="[checkAllExpand ? 'is-neutral' : 'is-click']" v-if="0 < data.countAll && data.countAll <= 500" class="one-touch-item"><icon-down style="margin-right: 4px" />展开</div>
          <div @click="oneTouchExpand(false)" :disabled="!checkAllCollapse" :class="[!checkAllCollapse ? 'is-neutral' : 'is-click']" class="one-touch-item"><icon-up style="margin-right: 4px" />收起</div>
        </div>
      </div>
    </template>
    <template v-else>
      <ly-skeleton fromType="mainTable" :lineHeight="22" :row="10"></ly-skeleton>
    </template>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" @cb="refreshList('detail')"></ly-detail>
    <div v-if="data.showColOverlay" :key="showColOverlayNum" class="overlay" @click.stop="showLay(false)"></div>
  </div>
</template>

<script setup lang="jsx">
import _ from 'lodash';
import { reactive, ref, onMounted, provide, computed, watch, KeepAlive, defineAsyncComponent, nextTick, toRefs } from 'vue';
import { layoutService, setService } from '@/api/';
import useFhTable from '@/hooks/fh-table';
import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import CONFIG from '@/config/config';
import { useUserStore, useLayoutStore, useFilterListStore } from '@/store';
import { editFieldTypeList, editEntityList, contractFieldKey, computingStatus } from '@/utils/const';
import useEditFields from '@/hooks/edit-field';
import useMainTable from '@/hooks/main-table';
import LyTemplateSlot from '@/components/layout/ly-template-slot/ly-template-slot.vue'; //列表插槽组件
// import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import LyListUniversalButtons from '@/components/layout/ly-list-universal-buttons/ly-list-universal-buttons.vue';
// import dayjs from 'dayjs';
const tableInnerEdit = defineAsyncComponent(() => import('../table-inner-edit/table-inner-edit.vue'));
const linkEditAble = defineAsyncComponent(() => import('../../unit/link-edit-able/link-edit-able.vue'));
const avatarEditAble = defineAsyncComponent(() => import('../../unit/avatar-edit-able/avatar-edit-able.vue'));
const textEditAble = defineAsyncComponent(() => import('../../unit/text-edit-able/text-edit-able.vue'));
const numberEditAble = defineAsyncComponent(() => import('../../unit/number-edit-able/number-edit-able.vue'));
const percentEditAble = defineAsyncComponent(() => import('../../unit/percent-edit-able/percent-edit-able.vue'));
const dateEditAble = defineAsyncComponent(() => import('../../unit/date-edit-able/date-edit-able.vue'));
const selectEditAble = defineAsyncComponent(() => import('../../unit/select-edit-able/select-edit-able.vue'));
const cascadeEditAble = defineAsyncComponent(() => import('../../unit/cascade-edit-able/cascade-edit-able.vue'));
const amountEditAble = defineAsyncComponent(() => import('../../unit/amount-edit-able/amount-edit-able.vue'));
const associationEditAble = defineAsyncComponent(() => import('../../unit/association-edit-able/association-edit-able.vue')); //查找关联多选
const departEditAble = defineAsyncComponent(() => import('../../unit/depart-edit-able/depart-edit-able.vue'));
const lyAvatar = defineAsyncComponent(() => import('../../layout/ly-avatar/ly-avatar.vue'));
const xlStatus = defineAsyncComponent(() => import('../../xl-status/xl-status.vue'));
const lyAttachmentList = defineAsyncComponent(() => import('../../layout/ly-attachment-list/ly-attachment-list.vue'));
const lyAssociation = defineAsyncComponent(() => import('../../layout/ly-association/ly-association.vue'));
const associationNonEditAble = defineAsyncComponent(() => import('../../unit/association-non-edit-able/association-non-edit-able.vue'));
const lyComputedCmp = defineAsyncComponent(() => import('../../unit/computed-cmp/computed-cmp.vue'));
const lyRichText = defineAsyncComponent(() => import('../../layout/ly-rich-text/ly-rich-text.vue'));
const lyTagFields = defineAsyncComponent(() => import('../../layout/ly-tag-fields/ly-tag-fields.vue'));
const useLayout = useLayoutStore(); //视图及布局store
const useFilterList = useFilterListStore(); // 筛选条件store
const { highConditionsList, getConditionList } = useMainTable();
import fieldPermission from '@/hooks/field-permission';
const { isRequiredField, isEditableField } = fieldPermission();
// const route = useRoute();
const { setEditFieldVal } = useEditFields();
const props = defineProps({
  entityId: {
    //对象的entity【必传】
    type: Number || String,
    default: undefined
  },
  viewId: {
    type: Number || String,
    default: undefined
  },
  record: {
    type: Object,
    default: () => ({})
  },
  // 按钮权限 & 字段信息
  fieldsListAll: {
    type: [Object, Array],
    default: () => {}
  },
  // 字段信息
  layoutFieldList: {
    type: [Object, Array],
    default: () => []
  },
  // 暂时去掉，是否展示操作区域根据是否配置按钮权限
  // operations: {
  //   //操作区域默认宽度是180，如有操作区域宽度请传参数
  //   type: Number,
  //   default: 180
  // },
  customerId: {
    type: Number || String
  },
  isFilter: {
    // 是否支持筛选，默认支持
    type: Boolean,
    default: true
  },

  fieldGroups: {
    type: Array,
    default: () => []
  }
});
const { t } = useI18n();

//类型1-线索 2-客户 3-商机 4-产品 6--报价单详情 7--报价单明细 8 销售合同 9 销售合同明细10销售订单13退货单14退货单产品
const entity = ref(props.entityId);

const detailKey = (entity) => {
  const keyMap = {
    //主属性
    1: 'companyName',
    2: 'customerName',
    3: 'opportunityName',
    4: 'productName',
    6: 'priceSheetCode',
    8: 'code', // 合同使用 'code'
    10: 'code', // 销售订单也使用 'code'
    12: 'salesNo',
    13: 'code', // 退货单也使用 'code'
    16: 'dynamicRecord',
    101: 'companyName' // 线索池也使用 'companyName'
  };
  return keyMap[entity] || '';
};

const slotList = computed(() => {
  if (entity.value === 1) {
    return ['clueStatus', 'intentionality', 'isImportant'];
  } else if (entity.value === 101) {
    return ['clueStatus', 'intentionality', 'isImportant'];
  } else if (entity.value === 2) {
    return ['customerName', 'qccId', 'intentionality', 'isDealt', 'important', 'lastFollowContent'];
  } else if (entity.value === 8) {
    return ['esignStatus', 'fsContractId'];
  } else if (entity.value === 10) {
    return ['totality', 'billPeriod', 'fsContractId', 'amount'];
  }
  {
    return [];
  }
});
const resizeRandom = ref(0);
const fieldsSort = ref([]);
const windowHeight = ref(0);
const listScroll = ref(null);
const lyListUniversalButtonsRef = ref(); //公共组件ref
const dynamicStyle = ref({
  position: 'absolute',
  top: '8px',
  left: '16px',
  zIndex: 99,
  display: 'none'
});
const data = reactive({
  //分页总条数
  countAll: 0,
  groupPageSize: 20,
  idsAll: [], // 全部ID
  indeterminate: false, //半选
  checkedDataAll: false, //全选
  dataPermission: 0,
  fieldList: [], //获取字段列表所有数据
  // filterFieldList: [], //筛选的字段
  customFieldList: [], //客户表头
  columns: [],
  columnsCopy: [],
  poolLoading: false, //线索池领取loading
  id: '', //ID、
  account_id: '',
  tab: '',
  loading: false,
  record: [],
  colors: { 建议转化: '#37b41a', 建议无效: 'var(--color-text-2)', 待定: 'gold', 待处理: 'orange', '': 'gray' },
  leadsID: [],
  viewId: null,
  activeRow: true,
  editFieldTypeList: [0, 1, 2, 3, 4, 5], //可编辑的字段类型
  editEntityList: { 1: ['mobile', 'personName'], 2: ['mobile', 'personName'], 3: ['mobile', 'personName', 'opportunityStage', 'opportunityStatus'], 4: [], 6: [], 7: [], 8: [], 9: [], 10: [], 11: [], 12: [], 13: [], 14: [], 32: [], 101: ['mobile', 'personName'] },
  // 客户模块
  bingDataInput_rbKcJb: '',
  // 合同签署
  signLoading: false,
  activeId: null,
  // 高级搜索
  conditionsValue: [],
  specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
  permissionsObjList: {
    //编辑权限
    1: 'clue:edit',
    2: 'customer:edit',
    3: 'businessOpportunity:edit',
    4: 'product:edit',
    6: 'priceSheet:edit',
    //   7: '报价单产品',
    8: 'contract:edit',
    //   9: '合同产品',
    10: 'saleOrder:edit',
    //   11: '订单产品',
    12: 'afterSale:edit',
    13: 'returnOrder:edit',
    16: 'dynamicRecord:edit',
    //   14: '退货单产品',
    //   32: '商机产品',
    101: 'cluePool:edit'
  },
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
    //conditions: [{ id: undefined, operation: 'and', isGroup: true, parentId: undefined, children: [{ id: undefined, operation: '', isGroup: false, parentId: undefined, field: '', value: null }] }]
  },
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ],
  showColOverlay: false, // 父组件弹窗状态
  colOverlayId: undefined // 哪列弹窗
});
const activeGroup1RowKeys = ref([]); //一组高亮行
const activeGroup2RowKeys = ref([]); //二组高亮行
const activeGroup3RowKeys = ref([]); //三组高亮行
const groupStructureLoading = ref(false);
// 所有表格的 document.querySelectorAll
const divElements = ref([]);
const observedIds = new Set();
// 解决蒙层不更新
const showColOverlayNum = ref(0);
const poolId = ref(); //线索池id
const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
const universalButtonParams = ref({});
//兼容自定义
if (entity.value >= 200) {
  data.permissionsObjList[entity.value] = `${entity.value}:edit`;
}
const emits = defineEmits(['cb', 'cbGroup']);
const detailRef = ref(); //公共抽离组件
const lyListShortcutRef = ref(null);
const fhTableRef = ref(null); // 表格ref
const fieldGroups = computed(() => props.fieldGroups);
// 是否在飞书环境ss
// const isFeiShuApp = window.h5sdk;
const setTableTrWidthStatus = ref(false);
const filterDataObj = ref({});
const { userInfo } = useUserStore(); //用户信息
const com2 = computed(() => {
  if (data.columns && data.columns?.length) {
    return data.columns?.filter((item) => item.colKey !== 'row-select');
  }
  return data.columns;
});
// const buttonTexts = ref([]);
// if (entity.value) {
//   buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, entity.value);
// }

const { fieldsListAll, layoutFieldList } = toRefs(props);
// 表格表头数据字段getFilterParams,fitlterLayoutFields,
// 可编辑表格的hooks
// const { getEditTableProps } = useEditTable();
// 点击行
// const rowClick = (context) => {
//   context.e.stopPropagation();
//   toDetails(context.row);
// };
const clearRowKeys = () => {
  //清空高亮行
  activeGroup1RowKeys.value = []; //一组高亮行
  activeGroup2RowKeys.value = []; //二组高亮行
  activeGroup3RowKeys.value = []; //三组高亮行
};
// 点击一组表格
const rowGroup1Click = (context) => {
  clearRowKeys();
  activeGroup1RowKeys.value.push(context.row.id);
  context.e.stopPropagation();
  toDetails(context.row);
};
// 点击行（二组）
const rowGroup2Click = (context) => {
  clearRowKeys();
  activeGroup2RowKeys.value.push(context.row.id);

  context.e.stopPropagation();
  toDetails(context.row);
};
// 点击行（三组）
const rowGroup3Click = (context) => {
  clearRowKeys();
  activeGroup3RowKeys.value.push(context.row.id);

  context.e.stopPropagation();
  toDetails(context.row);
};

const toDetails = (record) => {
  console.log(229, entity.value);
  if (data.specialProduct.includes(Number(entity.value))) {
    //特殊产品显示不能点击状态
    return false;
  }
  data.id = record?.id;
  detailRef.value?.closeDialog?.();
  if (entity.value == 1) {
    // 点击公司名称--线索详情
    data.tab = 'clueDetail';
  } else if (entity.value == 2) {
    //点击公司名称--客户详情
    data.tab = 'clientDetail';
  } else if (entity.value == 3) {
    // 点击商机名称--商机详情
    data.account_id = record.account_id;
    data.tab = 'opportunityDetail';
  } else if (entity.value == 4) {
    // 点击产品管理--产品管理详情
    data.tab = 'productDetail';
  } else if (entity.value == 6) {
    // 点击报价单名称--报价单详情
    data.tab = 'priceSheetDetail';
  } else if (entity.value == 8) {
    // 点击合同编号--合同详情
    data.tab = 'contractDetail';
  } else if (entity.value == 10) {
    // 点击销售订单编号--销售订单详情
    data.tab = 'orderDetail';
  } else if (entity.value == 12) {
    // 点击售后服务编号--售后服务详情
    data.tab = 'serviceDetail';
  } else if (entity.value === 13) {
    // 点击销售退货编号--销售退货单详情
    data.tab = 'returnOrderDetail';
  } else if (entity.value === 101) {
    // 点击线索池公司名称--线索池详情
    data.tab = 'cluePoolDetail';
  }
  detailRef.value.openDialog();
};
const highSearch = {};
// 获取scope的值
const scopeKey = `${CONFIG.prefix}_list_scope`;
const scopeLimit = ref(tools.getCookie(scopeKey) || 0);
// const poolHightSelectList = ref([]);

//搜索
const randomKey = computed(() => `${entity.value}_${data.viewId}`);
const filterParams = ref({});

const cb = async (data) => {
  console.log('开始获取', data);
  const businessIdList = data.map((dItem) => dItem.id);
  try {
    const json = await setService.getComputedErrorLog({
      entity: entity.value,
      businessIdList: businessIdList
    });
    if (!json.error) {
      const result = json.result;
      data.forEach((itemA) => {
        const matchingItem = result?.find((itemB) => itemB.businessId === itemA.id);
        if (matchingItem) {
          // 如果找到了匹配项，就把 computed 的值添加到 数据 中
          itemA.computedInfo = matchingItem;
        }
      });
      console.log('计算字段结果信息', result);
    }
  } catch (error) {
    console.log(error);
  }
  console.log('最终结果22', data);
};

//表格
const { tProps, tPropsEvent, setTProps, setLoadListParams, loadTList } = useFhTable(layoutService.getObjectListPage.bind(layoutService), cb);
// 设置额外的props
setTProps({
  uuid: computed(() => data.viewId)
});
const isFirst = ref(true); // 首次不触发保存筛选
const isObservable = ref(false);
// let hasObserved = false; // 新增标记变量
const renderStartTime = ref(null);
// const renderEndTime = ref(null);
// const renderDuration = ref(null);
// 高级筛选组件的回调事件
const getSearchData = _.debounce(async (v) => {
  console.log('getSearchData', v);
  data.conditionsValue = v;
  // 线索池特殊处理--存储线索池id
  if (entity.value == 101 && v?.sceneId) {
    poolId.value = v?.sceneId;
  }

  if (isFirst.value) {
    v.conditions = data.ruleForm?.conditions;
  } else {
    if (v?.conditions) {
      data.ruleForm.conditions = v?.conditions;
    }
    if (v?.searchConditions) {
      data.ruleForm.searchConditions = v?.searchConditions;
    }
    if (v.type) {
      // 保存筛选数据
      await useFilterList.setConditionsList({ entity: entity.value, conditions: v?.conditions });
    }
    console.log('groupDataInit', 1);
    groupDataInit();
  }

  delete v.type;
  // 更新筛选条件的值，导出组件使用
  const params = {
    viewId: data.viewId,
    filterParams: {
      conditions: v?.conditions,
      scope: v.sceneType === 0 ? v.sceneId : null,
      sceneId: v.sceneType === 1 ? v.sceneId : null,
      viewId: data.viewId,
      searchConditions: v?.searchConditions
    },
    pagination: tProps.value.pagination
  };
  // emits('cb', { type: 2, params });
  universalButtonParams.value = params;
  console.log(535, universalButtonParams.value);
  // 重置listPage接口参数
  selectTableIds.value = [];
  isFirst.value = false;
}, 0);

// 取树结构最后的数据
const LastData = (data) => {
  const result = [];
  function recursiveExtract(group) {
    for (const item of group) {
      item.label = item.value;
      item.textcolor = '';
      item.bgcolor = '';
      item.loading = true;
      item.loadingMore = false;
      item.ids = [];
      item.checkedAll = false;
      item.indeterminate = false;
      const fieldItem = layoutFieldList.value.find((sub) => sub.fieldKey == item.groupFieldKey);
      if (fieldItem) {
        //const colors = ['#f53f3f', '#7816ff', '#00b42a', '#165dff', '#ff7d00', '#eb0aa4', '#7bc616', '#86909c', '#b71de8', '#0fc6c2', '#ffb400', '#168cff', '#ff5722'];
        const colors = ['red', 'orangered', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'arcoblue', 'purple', 'pinkpurple', 'magenta', 'gray'];
        const randomIndex = Math.floor(Math.random() * colors.length);
        // 给一个随机颜色
        item.bgcolor = colors[randomIndex];
        // 取后台配置颜色
        if (fieldItem.fieldType == 2 || fieldItem.fieldType == 4) {
          if (tools.isJSON(fieldItem?.fieldExt)) {
            const fieldExt = JSON.parse(fieldItem?.fieldExt);
            if (fieldExt.length) {
              const m = fieldExt.find((m) => m.label == item.label);
              if (m && m?.background) {
                item.bgcolor = m?.background;
                item.textcolor = m?.color;
              }
            }
          }
        }
      }
      if (item.groups && item.groups.length > 0) {
        if (item.groupFieldType == 6 && item?.business?.userName) item.label = item?.business?.userName;
        if (item.groupFieldType == 22 && item?.business?.name) item.label = item?.business?.name;
        if (item.groupFieldType == 12 && item?.business?.label) item.label = item?.business?.label;
        if (item.groupFieldType == 8) item.label = item.value.split(' ')[0];
        if (item.groupFieldType == 7 && !isNaN(parseFloat(item.label))) {
          const getFieldExt = tools.isJSON(fieldItem?.fieldExt) && JSON.parse(fieldItem?.fieldExt);
          item.label = parseFloat(item.label).toFixed(getFieldExt?.numberFormat != 100 ? getFieldExt?.numberFormat : 3) + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
        }
        if (item.groupFieldType == 16) {
          item.label = !isNaN(parseFloat(item.label)) ? tools.getPriceShow(item.label, fieldItem?.fieldExt) : '';
        }
        recursiveExtract(item.groups, item.newPath);
      } else {
        if (item.groupFieldType == 6 && item?.business?.userName) item.label = item?.business?.userName;
        if (item.groupFieldType == 22 && item?.business?.name) item.label = item?.business?.name;
        if (item.groupFieldType == 12 && item?.business?.label) item.label = item?.business?.label;
        if (item.groupFieldType == 8) item.label = item.value.split(' ')[0];
        if (item.groupFieldType == 7 && !isNaN(parseFloat(item.label))) {
          const getFieldExt = tools.isJSON(fieldItem?.fieldExt) && JSON.parse(fieldItem?.fieldExt);
          item.label = parseFloat(item.label).toFixed(getFieldExt?.numberFormat != 100 ? getFieldExt?.numberFormat : 3) + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
        }
        if (item.groupFieldType == 16) {
          item.label = !isNaN(parseFloat(item.label)) ? tools.getPriceShow(item.label, fieldItem?.fieldExt) : '';
        }
        item.groupKey = 'index' + item.index;
        result.push(item);
      }
    }
  }
  recursiveExtract(data);
  return result;
};
// 追加唯一索引  统计总条数
const addIndexToData = (data, parentIndex = '') => {
  let index = 0;
  return data.map((item) => {
    const currentIndex = parentIndex ? `${parentIndex}-${index}` : `${index}`;
    item.index = currentIndex;
    if (item.groups) {
      item.groups = addIndexToData(item.groups, currentIndex);
    }
    index++;
    return item;
  });
};

// 追加显示状态
const addAaaField = (data, countAll) => {
  if (!data?.length) return;
  data.forEach((item) => {
    if (item.groups) {
      addAaaField(item.groups, countAll);
      item.isShow = true;
    } else {
      if (countAll * 1 <= 500) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
    }
  });
  return data;
};

// 父级节点 含目标节点 追加ids
const addParentsIds = (data, targetIndex, ids) => {
  function recursiveFind(node) {
    if (node.index === targetIndex) {
      node.ids = [...new Set([...(node.ids || []), ...ids])];
      return true;
    }
    if (node.groups) {
      for (var group of node.groups) {
        if (recursiveFind(group)) {
          node.ids = [...new Set([...(node.ids || []), ...ids])];
          return true;
        }
      }
    }
    return false;
  }
  for (var item of data) {
    if (recursiveFind(item)) {
      break;
    }
  }
  return data;
};

// 加载更多
const getMore = async (item) => {
  try {
    const page = arrLL[item.groupKey + 'Page'];
    const params = arrLL[item.groupKey + 'params'];
    // 是否有单字段排序
    const updatedParams = hasSingleFieldSort(useFilterList, params);
    setLoadListParams(updatedParams);
    tProps.value.pagination.pageSize = data.groupPageSize;
    item.loadingMore = true;
    const json = await loadTList(page);
    if (!json.error && Array.isArray(json.result?.records) && json.result?.records?.length) {
      arrLL[item.groupKey].data = arrLL[item.groupKey].data.concat(json.result?.records);
      // 当前页小于总分页
      if (arrLL[item.groupKey + 'Page'] < json.result?.pages) {
        arrLL[item.groupKey + 'Page'] = json.result?.current + 1;
      }
      const ids = arrLL[item.groupKey].data?.map((mm) => mm.id);
      addParentsIds(arrLL.group, item.index, ids);
      arrLL.group?.forEach((item) => {
        data.idsAll = [...new Set([...data.idsAll, ...item.ids])];
      });
      checkGroupAllData(arrLL.group);
      checkAllData();
      item.loadingMore = false;
    } else {
      item.loadingMore = false;
      Message.error(json.error?.msg || '加载失败，请重试');
    }
    // data.loading = false;
  } catch (e) {
    console.log(e);
    item.loadingMore = false;
    Message.error(e.message || e.statusText || '加载失败，请重试');
  }
};
// const skeletonTableCell = async () => {
//   if (isObservable.value) {
//     console.log(654, fhTableRef.value);
//     const observeTableRender = () => {
//       return new Promise((resolve) => {
//         const observer = new MutationObserver(() => {
//           requestAnimationFrame(() => {
//             if (fhTableRef.value?.length && fhTableRef.value?.[0]?.fhTableRef) {
//               renderEndTime.value = performance.now();
//               renderDuration.value = renderEndTime.value - renderStartTime.value;
//               observer.disconnect();
//               resolve();
//             } else {
//               renderDuration.value = 0;
//             }
//           });
//         });
//         if (observer?.observer && fhTableRef.value?.length && fhTableRef.value?.[0]?.fhTableRef && !hasObserved) {
//           observer.observe(fhTableRef.value?.[0]?.fhTableRef, {
//             childList: true,
//             subtree: true
//           });
//           hasObserved = true; // 调用后设置为已调用
//         } else {
//           renderDuration.value = 0;
//           resolve(); // 直接 resolve，避免 Promise 一直处于 pending 状态
//         }
//       });
//     };
//     await observeTableRender();
//     setTimeout(() => {
//       isObservable.value = false;
//     }, renderDuration.value);
//   }
// };
// 切换显示状态 并请求数据
const switchIsShow = async (item) => {
  item.isShow = !item.isShow;
  nextTick(async () => {
    if (arrLL[item.groupKey]?.data?.length) return;
    const page = arrLL[item.groupKey + 'Page'];
    const params = arrLL[item.groupKey + 'params'];
    // 是否有单字段排序
    const updatedParams = hasSingleFieldSort(useFilterList, params);
    setLoadListParams(updatedParams);
    tProps.value.pagination.pageSize = data.groupPageSize;
    item.loading = true;
    // data.loading = true;
    const json = await loadTList(page);
    // 此处开始观察获取列表数据到table内容渲染的时间
    renderStartTime.value = performance.now();
    // 记录开始时间
    // skeletonTableCell();
    // data.loading = false;
    arrLL[item.groupKey] = JSON.parse(JSON.stringify(tProps.value));
    const ids = arrLL[item.groupKey].data?.map((mm) => mm.id);
    addParentsIds(arrLL.group, item.index, ids);
    arrLL.group?.forEach((item) => {
      data.idsAll = [...new Set([...data.idsAll, ...item.ids])];
    });
    checkGroupAllData(arrLL.group);
    checkAllData();
    item.loading = false;
    if (!json.error && json.result?.current) {
      // 当前页小于总分页
      if (arrLL[item.groupKey + 'Page'] < json.result?.pages) {
        arrLL[item.groupKey + 'Page'] = json.result?.current + 1;
      }
    }
  });
  // 请求数据回填值
};

const groupDataInit = _.debounce(async () => {
  await groupStructure();
  await getDataList();
  await setTableTrWidth();
}, 500);

// 生成 label 到索引的映射
const createLabelIndexMap = (fieldExt) => {
  const parsedFieldExt = JSON.parse(fieldExt);
  const map = {};
  parsedFieldExt.forEach((item, index) => {
    map[item.label] = index;
  });
  return map;
};

// 递归排序函数
const childrenSort = (data, data2) => {
  if (!Array.isArray(data)) return data;
  if (data.length === 0) return data;
  const groupFieldKey = data[0].groupFieldKey;
  const matchingData2 = data2.find((item) => item.fieldKey === groupFieldKey);
  // 下拉单选 单选按钮
  if (matchingData2 && [2, 4].includes(matchingData2.fieldType)) {
    const labelIndexMap = createLabelIndexMap(matchingData2.fieldExt);
    data.sort((a, b) => {
      const indexA = labelIndexMap[a.value] !== undefined ? labelIndexMap[a.value] : Infinity;
      const indexB = labelIndexMap[b.value] !== undefined ? labelIndexMap[b.value] : Infinity;
      return indexA - indexB;
    });
  }
  // 递归处理子层数据
  data.forEach((item) => {
    if (item.groups) {
      item.groups = childrenSort(item.groups, data2);
    }
  });
  return data;
};

// 单选排序
const radiosSort = (data) => {
  const _fieldArray = fieldGroups.value?.map((item) => {
    const fieldItem = layoutFieldList.value.find((sub) => sub.fieldKey == item.fieldKey);
    return { ...item, ...fieldItem };
  });
  return childrenSort(data, _fieldArray);
};

// 获取分组结构
const groupStructure = async () => {
  try {
    const params = {
      entity: entity.value * 1,
      id: data.viewId || props.viewId,
      scope: data?.conditionsValue?.sceneType === 0 ? data?.conditionsValue.sceneId : null,
      sceneId: data?.conditionsValue?.sceneType === 1 ? data?.conditionsValue?.sceneId : null,
      conditions: data.ruleForm?.conditions || [],
      searchConditions: data.ruleForm.searchConditions || [],
      page: 1,
      pageSize: 100
    };
    // 是否有单字段排序
    const updatedParams = hasSingleFieldSort(useFilterList, params);
    // 新增逻辑过滤已经停用的字段
    if (fieldGroups.value?.filter((item) => item.fieldStatus == 1)?.length) {
      updatedParams.fieldGroups = fieldGroups.value?.filter((item) => item.fieldStatus == 1);
    } else {
      Message.error('该分组字段被停用!');
      return;
    }
    groupStructureLoading.value = true;
    const json = await layoutService.groupStructure(updatedParams);

    if (!json.error) {
      if (json?.result?.groups) {
        // 下拉单选排序
        json.result.groups = radiosSort(json?.result?.groups);
        data.idsAll = [];
        arrLL.group = json?.result?.groups || [];
        arrLL.group = addIndexToData(arrLL.group);
        setTableTrWidthStatus.value = false;
        data.countAll = 0;
        if (arrLL.group && arrLL.group.length) {
          arrLL.group.forEach((item) => {
            data.countAll = data.countAll + item.count;
          });
          arrLL.group = addAaaField(arrLL.group, data.countAll);
          console.log('arrLL.group', arrLL.group);
        }
        groupStructureLoading.value = false;
      } else {
        groupStructureLoading.value = false;
        Message.error('获取分组结构为空!');
        return;
      }
    } else {
      groupStructureLoading.value = false;
      Message.error(json.error?.msg || '获取分组结构失败!');
    }
  } catch (e) {
    groupStructureLoading.value = false;
    // Message.error(e.message || e.statusText || '获取分组结构失败!');
    console.log(e);
  }
};

const arrLL = reactive({
  fieldKeys: [],
  arrayGroup: [],
  entity: '',
  viewId: '',
  group: []
});

const getDataList = _.debounce(async (filterParams = null) => {
  arrLL.arrayGroup = [];
  arrLL.arrayGroup = LastData(arrLL.group);
  console.log('arrLL', arrLL);
  for (let i = 0; i < arrLL.arrayGroup.length; i++) {
    const item = arrLL.arrayGroup[i];
    // 整理条件
    const conditions = JSON.parse(JSON.stringify(data.ruleForm?.conditions));
    conditions?.forEach((nm) => {
      nm.children = nm.children.concat(item.conditions.children);
    });
    const params = { conditions: conditions?.length ? conditions : [item.conditions], id: data.viewId || props.viewId, entity: entity.value };
    if (filterParams) {
      params.sortSettings = filterParams.sortSettings;
    }
    if (data.ruleForm.searchConditions) {
      params.searchConditions = data.ruleForm.searchConditions;
    }
    params.scope = data?.conditionsValue?.sceneType === 0 ? data?.conditionsValue.sceneId : null;
    params.sceneId = data?.conditionsValue?.sceneType === 1 ? data?.conditionsValue?.sceneId : null;
    // setLoadListParams(params);
    // tProps.value.pagination.pageSize = 10;
    // await loadTList(1);
    if (item && item.groupKey) {
      arrLL.fieldKeys.push(item.groupKey);
      arrLL[item.groupKey] = [];
      arrLL[item.groupKey + 'Page'] = 1;
      arrLL[item.groupKey + 'params'] = JSON.parse(JSON.stringify(params));
    }
  }

  observedIds.clear();
  seeTarget();
}, 300);

const cbGroup = (v) => {
  const columns = _.cloneDeep(data.columns);
  data.columns = [];
  fhTableRef.value?.forEach((item) => {
    item.getCols(v);
  });
  data.columns = columns;
};
const fhOutTableRef = ref(null);
// 打开列选择
const openColSelect = () => {
  fhOutTableRef.value?.openColSelect();
};
// 刷新表格
// const refreshTable = (index, params) => {
//   setData(index, params);
// };
// 比较两个数组包含关系   所有 部分 没有   array1分组的   array2选择的
const checkArrayRelation = (array1, array2) => {
  let allInArray2 = true;
  let noneInArray2 = true;
  for (var item of array1) {
    if (!array2.includes(item)) {
      allInArray2 = false;
    } else {
      noneInArray2 = false;
    }
  }
  if (allInArray2) {
    // 所有
    return '1';
  } else if (noneInArray2) {
    // 没有
    return '2';
  } else {
    // 部分
    return '3';
  }
};

// 递归比较两个数组包含关系
const checkGroupAllData = (data) => {
  data.forEach((item) => {
    const checkedStatus = checkArrayRelation(item.ids, selectTableIds.value);
    if (checkedStatus == 1) {
      item.checkedAll = true;
      item.indeterminate = false;
    }
    if (checkedStatus == 2) {
      item.checkedAll = false;
      item.indeterminate = false;
    }
    if (checkedStatus == 3) {
      item.checkedAll = false;
      item.indeterminate = true;
    }
    if (item.groups) {
      checkGroupAllData(item.groups);
    }
  });
  return data;
};

// 校验是否全选
const checkAllData = () => {
  if (selectTableIds.value?.length == data.idsAll.length && data.idsAll.length) {
    data.checkedDataAll = true;
    data.indeterminate = false;
  } else if (selectTableIds.value?.length > 0 && selectTableIds.value?.length < data.idsAll.length) {
    data.indeterminate = true;
    data.checkedDataAll = false;
  } else {
    data.checkedDataAll = false;
    data.indeterminate = false;
  }
};

// 全部全选
const setCheckedAlls = () => {
  data.checkedDataAll = !data.checkedDataAll;
  if (data.checkedDataAll) {
    selectTableIds.value = data.idsAll;
    data.indeterminate = false;
  } else {
    selectTableIds.value = [];
  }
  checkGroupAllData(arrLL.group);
};

//分组全选
const setCheckedGroupAll = (e) => {
  e.checkedAll = !e.checkedAll;
  if (e.ids?.length) {
    // 全选
    if (e.checkedAll) {
      selectTableIds.value = [...new Set([...selectTableIds.value, ...e.ids])];
    }
    // 反选
    if (!e.checkedAll) {
      selectTableIds.value = selectTableIds.value.filter((item) => !e.ids.includes(item));
    }
  }

  checkGroupAllData(arrLL.group);
  checkAllData();
};

const ids = ref([]);
const bingDataList = ref([]);
const selectTableIds = ref([]); //选择的数据ID
const fhTableSelect = (rowKeys) => {
  console.log('分组选项', rowKeys, arrLL.group);
  const handleIndex = selectTableIds.value?.findIndex((item) => item == rowKeys);
  if (handleIndex > -1) {
    // 已经存在
    selectTableIds.value.splice(handleIndex, 1);
  } else {
    selectTableIds.value.push(rowKeys);
  }
  // selectTableIds.value = rowKeys;
  checkGroupAllData(arrLL.group);
  checkAllData();
  //选择当前页
  const list = tProps.value.data;
  const filterList = list?.filter((v) => selectTableIds.value?.includes(v.id));
  console.log('rowKeys', rowKeys);
  if (entity.value == 2) {
    bingDataList.value = filterList.map((v) => v.input_rbKcJb);
  } else if (entity.value == 3) {
    bingDataList.value = filterList.map((v) => v.account_id);
  } else if (entity.value == 10) {
    bingDataList.value = filterList.map((v) => v.id);
  } else if (entity.value >= 200 && userInfo?.roles?.indexOf(`${entity.value}:bingUserInviteSync`) !== -1) {
    bingDataList.value = filterList.map((v) => v?.id);
  }
  if (selectTableIds.value?.length === 0) {
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(fieldsListAll.value.buttonUniversal);
  }
};
// 分页改变触发时如果批量操作中有数据，则清空数据
const fhTablePagination = ({ pagination }) => {
  if (pagination && selectTableIds.value?.length) {
    selectTableIds.value = [];
  }
};
// 获取所有字段值,生成表格头部
const buttonBatch = ref([]);
const buttonShortcut = ref([]);
const operationItem = computed(() => {
  return buttonShortcut.value?.length === 0 ? 0 : buttonShortcut.value?.length <= 3 ? 120 : 200;
});
const searchInit = (viewId) => {
  filterDataObj.value = {
    viewId: viewId.viewId,
    entity: entity.value,
    highSearch: {
      value: scopeLimit.value ? Number(scopeLimit.value) : 0,
      list: []
    },
    fieldSearch: {
      value: '',
      list: []
    }
  };
};
const isShowFilter = ref(false);
const fieldFilterList = ref([]); //字段筛选下拉选项值
const skeletonLoading = ref(false);
// const highFilterObj = ref({});
const getField = async (viewId) => {
  isShowFilter.value = false;
  clearRowKeys();
  data.viewId = viewId?.viewId || props.viewId;
  data.dataPermission = viewId.dataPermission;
  // data.loading = true;
  await getConditionList(); //获取高级筛选下拉选项值
  searchInit(viewId);
  data.fieldList = layoutFieldList.value; //列表显示的字段 //.filter((v) => v.fieldType !== 18);
  if (useFilterList?.fieldsSort && useFilterList?.fieldsSort?.length) {
    addFieldsSort(data.fieldList, useFilterList?.fieldsSort);
  }
  fieldFilterList.value = fieldsListAll.value?.dropdowns;
  // 批量按钮权限
  if (fieldsListAll.value?.buttonBatch?.length) {
    buttonBatch.value = fieldsListAll.value?.buttonBatch.map((item) => item.value);
  }
  // 快捷按钮权限
  if (fieldsListAll.value?.buttonShortcut?.length) {
    buttonShortcut.value = fieldsListAll.value?.buttonShortcut.map((item) => item.value);
  }

  //刷新父组件ly-list中公共区域的按钮权限
  emits('cb', { type: 1, params: fieldsListAll.value });
  nextTick(() => {
    data.columns = getColumns();
    console.log('数据列', data.columns);
    lyListUniversalButtonsRef.value?.getBtnPermissionObj(fieldsListAll.value.buttonUniversal);
  });
  // isShowFilter的作用：保证再拿到数据后才渲染筛选组件；
  isShowFilter.value = true;
};
const skeletonStyles = {
  display: 'inline-block',
  width: '100%',
  height: '24px',
  backgroundColor: 'var(--color-fill-2)',
  animation: 'skeleton-blink 1s infinite alternate, skeleton-flow 1s infinite linear',
  backgroundImage: 'linear-gradient(90deg, var(--color-fill-2) 25%, rgba(255, 255, 255, 0.3) 50%, var(--color-fill-2) 75%)',
  backgroundSize: '400% 100%'
};
// 表格的render抽离
const setRender = (h, params) => {
  const setEntity = entity.value; //兼容多层级表格，多层级表格是传过来的entity（entity.value是主表对象，params.entity是多层级对象）
  let setFieldValue = params.fieldValue;
  const isPermissionEdit = isEditableField(params._ruleFieldKey, params?.PERMISSION);
  const isEditTableRow = isPermissionEdit && params?.oldFieldType != 21 && !editFieldTypeList?.includes(params.fieldType) && params.type != 0 && ((setEntity >= 200 && params.fieldKey != 'chargePerson') || (setEntity < 200 && !editEntityList[setEntity]?.includes(params.fieldKey))) && !contractFieldKey.includes(params.fieldKey);
  const editParams = {
    fieldInfo: params?.fieldInfo,
    isList: true,
    loading: data.loading,
    entity: setEntity,
    fieldValue: setFieldValue,
    originalValue: params.fieldValue, //原值
    fieldExt: params.fieldExt,
    fieldType: params.fieldType,
    fieldKey: params.fieldKey,
    fieldName: params.fieldName,
    isRequired: params?.isRequired, //是非必填
    mainField: params.mainField,
    subEntityId: params?.subEntityId, //子表单的EntityId
    isSubForm: params?.isSubForm, //是子表
    uniqueValue: params.record['id'] + params.id, //唯一值
    businessId: params.record['id'], //这条数据的id
    permissions: params.record['LOGIC_ROLE_PERMISSION'], //权限
    status: params.record['status'], //生命状态
    statusOrigin: params.record['statusOrigin'], //生命状态
    lockedOrigin: params.record['lockedOrigin'], // 锁定
    computedInfo: params.record?.['computedInfo'] ? params.record?.['computedInfo'] : params?.computedInfo ? params.computedInfo : null //计算状态
  };
  // 创建映射对象，将不同的fieldType值或范围映射到对应的组件上
  const componentMap = {
    0: textEditAble,
    1: textEditAble,
    2: selectEditAble,
    3: selectEditAble,
    4: selectEditAble,
    5: selectEditAble,
    6: avatarEditAble,
    7: numberEditAble,
    8: dateEditAble,
    9: dateEditAble,
    10: cascadeEditAble,
    11: linkEditAble,
    12: linkEditAble,
    16: amountEditAble,
    22: departEditAble,
    23: percentEditAble,
    25: associationEditAble,
    26: textEditAble
  };
  // 创建对象映射不可编辑组件
  const moreComponentMap = {
    4: xlStatus,
    6: lyAvatar,
    12: lyAssociation,
    18: lyAttachmentList,
    25: associationNonEditAble,
    26: lyRichText
  };
  const nSelectComponent = moreComponentMap[params.fieldType];
  // 从映射对象中获取对应的组件，如果不存在则使用默认的tableInnerEdit组件
  const selectedComponent = componentMap[params.fieldType] || tableInnerEdit;
  if ((params.fieldValue || params.fieldValue === 0) && params.fieldValue !== '') {
    setFieldValue = setEditFieldVal(params.fieldType, params.fieldValue, params.fieldExt); //处理可编辑字段的值
    // 可编辑逻辑
    if (isEditTableRow) {
      if (isObservable.value) {
        return h('div', {
          style: skeletonStyles
        });
      } else if (data.loading) {
        return h('div', {
          style: skeletonStyles
        });
      } else {
        return h(KeepAlive, {}, () =>
          h(
            selectedComponent,
            selectedComponent == tableInnerEdit
              ? editParams
              : {
                  editParams,
                  onCb: (cbParams) => {
                    if (cbParams?.businessId) {
                      if (params?.isSubForm) {
                        //替换成主数据id获取权限规则
                        cbParams.subFormFieldKey = params?._ruleFieldKey?.split('.')?.[0];
                        cbParams.subId = cbParams.businessId;
                        cbParams.businessId = params?.parentBusinessId;
                      }
                      updateFieldPermission(cbParams);
                    }
                  }
                }
          )
        );
      }
    } else {
      // 不可编辑逻辑
      if (setEntity === 4 && params.fieldType === 4 && params.fieldKey === 'taxRate') {
        //产品对象的税率特殊处理
        return tools.getPercentage(params.fieldValue, 0) + '%' || '';
      } else if (params.fieldType === 4 && params.fieldKey === 'status') {
        //生命状态
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(nSelectComponent, {
              status: params.fieldValue, //生命状态
              statusOrigin: params.record['statusOrigin'], //生命状态
              rollbackRoot: params.record['rollbackRoot'] // 退回状态
            })
          );
        }
      } else if (params.fieldType === 6) {
        // 人员
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          return h(KeepAlive, {}, () =>
            h(nSelectComponent, {
              record: params.fieldValue
            })
          );
        }
      } else if (params.fieldType === 11) {
        //超链接
        return h(
          'a',
          {
            style: {
              color: '#165dff',
              cursor: 'pointer'
            },
            href: params.fieldValue,
            target: '_blank'
          },
          t('查看')
        );
      } else if (params.fieldType === 18) {
        //附件
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          const Cpm = defineAsyncComponent(() => import('../../layout/ly-attachment-list/ly-attachment-list.vue'));
          return h(KeepAlive, {}, () =>
            h(Cpm, {
              fieldValue: params.fieldValue
            })
          );
        }
      } else if (params.fieldType === 12) {
        //查找关联单选
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          const Cpm = defineAsyncComponent(() => import('../../layout/ly-association/ly-association.vue'));
          return h(KeepAlive, {}, () =>
            h(Cpm, {
              isList: true,
              value: params.fieldValue,
              entity: params.fieldExt,
              listEntity: setEntity
            })
          );
        }
      } else if (params.fieldType === 25) {
        //查找关联对选
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          const Cpm = defineAsyncComponent(() => import('../../unit/association-non-edit-able/association-non-edit-able.vue'));
          return h(KeepAlive, {}, () => h(Cpm, { editParams }));
        }
      } else if (params.fieldType === 24) {
        //计算类型
        return h(KeepAlive, {}, () => h(lyComputedCmp, { params }));
        // if (params.fieldExt && tools.isJSON(params.fieldExt)) {
        //   const getFieldExt = JSON.parse(params.fieldExt);
        //   if (getFieldExt.type == 6 || getFieldExt.type == 16) {
        //     //汇总金额及金额类型
        //     return (params.fieldValue && tools.getPriceShow(params.fieldValue, getFieldExt?.dataType)) || '-';
        //   } else if (getFieldExt.type == 23) {
        //     //百分比
        //     return tools.getPercentage(params.fieldValue).toFixed(getFieldExt?.dataType) + '%' || '-';
        //   } else {
        //     return params.fieldValue ?? '-';
        //   }
        // } else {
        //   return params.fieldValue ?? '-';
        // }
      } else if (params.fieldType === 26) {
        if (isObservable.value) {
          return h('div', {
            style: skeletonStyles
          });
        } else if (data.loading) {
          return h('div', {
            style: skeletonStyles
          });
        } else {
          const Cpm = defineAsyncComponent(() => import('../../layout/ly-rich-text/ly-rich-text.vue'));
          return h(Cpm, {
            fieldValue: params.fieldValue
          });
        }
      } else {
        if (params.fieldType === 23 && !isNaN(parseFloat(setFieldValue))) return setFieldValue + '%';
        if (params.fieldType === 7 && !isNaN(parseFloat(setFieldValue))) {
          const getFieldExt = tools.isJSON(params.fieldExt) && JSON.parse(params.fieldExt);
          return setFieldValue + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
        }
        if ([2, 3, 4, 5, 10].includes(params.fieldType)) {
          return h(KeepAlive, {}, () =>
            h(lyTagFields, {
              isList: true,
              fieldValue: setFieldValue,
              styleInfo: params.fieldExt,
              fieldType: params.fieldType,
              fieldKey: params.fieldKey,
              fieldName: params.fieldName
            })
          );
        }
        if (params.mainField) {
          //主属性字段
          return h(
            'span',
            {
              style: {
                color: '#165dff',
                cursor: 'pointer'
              }
            },
            params.fieldValue?.label ?? params.fieldValue?.value ?? setFieldValue ?? '-'
          );
        } else {
          return params.fieldValue?.label ?? params.fieldValue?.value ?? setFieldValue ?? '-';
        }
      }
    }
  } else {
    if (isEditTableRow) {
      if (isObservable.value) {
        return h('div', {
          style: skeletonStyles
        });
      } else if (data.loading) {
        return h('div', {
          style: skeletonStyles
        });
      } else {
        return h(KeepAlive, {}, () => h(selectedComponent, { editParams }));
      }
    } else {
      if (params.mainField) {
        //主属性字段
        return h(
          'span',
          {
            style: {
              color: '#165dff',
              cursor: 'pointer'
            }
          },
          params.fieldValue == '' ? '-' : params.fieldValue?.label ?? params.fieldValue?.value ?? params.fieldValue ?? '-'
        );
      } else {
        if (params.fieldType === 24) {
          // 计算字段特殊处理
          return h(KeepAlive, {}, () => h(lyComputedCmp, { params }));
        }
        return params.fieldValue == '' ? '-' : params.fieldValue?.label ?? params.fieldValue?.value ?? params.fieldValue ?? '-';
      }
    }
  }
};
// 创建操作列配置
const createOperationColumn = () => ({
  colType: false,
  // resizable:false,
  title: () => {
    return <span style={{ color: 'rgb(var(--gray-10))' }}> {t('操作')}</span>;
  },
  stopPropagation: true,
  colKey: 'operations',
  fixed: 'right',
  width: operationItem.value
});
// 创建选择行的列配置
const createRowSelectColumn = () => ({
  colType: false,
  colKey: 'row-select',
  fixed: 'left',
  type: 'multiple',
  width: 46,
  resizable: false,
  checkProps: ({ row }) => {
    return {
      // 计算异常禁止选择
      disabled: computingStatus.includes(row?.computedInfo?.status)
    };
  }
});

// 创建计算状态列配置
const createRowComputedColumn = () => ({
  colType: false,
  colKey: 'computed-status',
  fixed: 'left',
  align: 'right',
  resizable: false,
  width: 30
});

// 自定义操作列
const customOperationColumn = () => ({
  title: 'custom-operations-title',
  colType: false,
  colKey: 'custom-operations',
  fixed: 'left',
  width: 46,
  resizable: false,
  className: 'custom-operations'
});

// 创建列配置
const createColumnConfig = (item) => {
  const k = item.fieldKey; //字段标识
  const frozen = item.frozen; //是否为固定行
  const fieldType = item.fieldType == 21 ? item?.business?.fieldType : item?.fieldType;
  const fieldExt = item.fieldType == 21 ? item?.business?.fieldExt : item?.fieldExt;
  //可编辑的字段类型
  const isEditTableRow = !editFieldTypeList?.includes(fieldType) && item.type != 0 && ((entity.value >= 200 && item.fieldKey != 'chargePerson') || (entity.value < 200 && !editEntityList[entity.value]?.includes(item.fieldKey))) && !contractFieldKey.includes(item.fieldKey);
  const width = item.mainField ? 250 : tools.getStrLen(item.fieldName) <= 6 ? 120 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 20;
  // 表格的className属性设置单元格的类名
  const colType = {
    title: item.fieldType == 27 ? item.fieldName : (h, { col }) => <ly-col-more col={col} record={item} fieldName={item.fieldName} findAssociation={findAssociation} ruleForm={data.ruleForm} viewId={data.viewId} colOverlayId={data.colOverlayId} showColOverlay={data.showColOverlay} getSearchDataCb={getSearchData} sortCb={sortChange} cb={colTitleFrozen} showLayCb={showLay} isSubForm={false} />,
    colKey: k,
    type: item.type,
    ellipsisTitle: { theme: 'light' },
    ellipsis: isEditTableRow || [3, 5, 12, 25].includes(fieldType) || (item.type == 0 && fieldType == 5) ? undefined : { theme: 'default' },
    id: item.id,
    stopPropagation: [12, 25].includes(fieldType) ? true : false,
    fieldName: item.fieldName,
    fieldType: fieldType,
    fieldExt: fieldExt,
    resize: tools.getStrLen(item.fieldName) <= 5 ? { minWidth: 120 } : tools.getStrLen(item.fieldName) > 10 ? { minWidth: 300 } : { minWidth: tools.getStrLen(item.fieldName) * 30 },
    className: item.fieldType == 27 ? 'sub-form-table-border' : '',
    fixed: frozen ? 'left' : undefined
  };
  // 表格的cell函数
  const render = (h, { row }) => {
    const record = JSON.parse(JSON.stringify(row));
    const params = {
      ...item,
      isRequired: isRequiredField(item.fieldKey, row.PERMISSION, item.isRequired),
      fieldValue: record[k],
      fieldType: fieldType,
      oldFieldType: item.fieldType, //兼容引用字段
      fieldExt: fieldExt,
      record: record,
      PERMISSION: row.PERMISSION,
      _ruleFieldKey: item?.fieldKey,
      fieldInfo: item
    };
    return setRender(h, params);
  };
  if (item.type === 1) {
    colType.colType = t(t('基础字段'));
  }
  if (k === detailKey(entity.value) && !isEditTableRow) {
    //跳转详情的key

    colType.slotName = k;
    colType.width = 250;

    //自定义插槽
  } else if (slotList.value?.indexOf(k) > -1) {
    // 2024/07/26曹建博去掉自定义插槽 slotName: k，添加render,

    colType.slotName = k;
    colType.width = 200;
  } else if (fieldType === 8 || fieldType === 9 || fieldType === 18) {
    colType.width = 200;
    colType.cell = render;
  } else {
    colType.width = width;
    colType.cell = render;
  }
  return colType;
};
// 创建子表单列配置
const createChildColumns = (item) => {
  const colTypeChildren = [];
  item?.fieldVos?.forEach((el, index) => {
    const childRender = (h, { row }) => {
      const record = JSON.parse(JSON.stringify(row));
      const subFormData = record?.[item?.fieldKey] || [];
      // 遍历子表单数据，为每个子表单记录渲染单元格
      if (subFormData?.length > 0) {
        return h('p', { class: 'child-table-container' }, [
          ...subFormData.map((subFormRecord) => {
            const params = {
              ...el,
              fieldInfo: el, //兼容查找关联编辑，需要拼接字段的modules结构
              isRequired: isRequiredField(`${item?.fieldKey}.${el?.fieldKey}`, row.PERMISSION, el.isRequired),
              fieldValue: subFormRecord?.[el.fieldKey] || '', // 使用子表单中的数据
              record: subFormRecord, // 使用子表单中的数据
              subEntityId: item.fieldExt, //子表单的entityId
              isSubForm: true, //是子表
              PERMISSION: row?.PERMISSION,
              _ruleFieldKey: `${item?.fieldKey}.${el?.fieldKey}`,
              parentBusinessId: row?.id,
              computedInfo: record?.computedInfo ? record?.computedInfo : null
            };
            return h('p', { class: 'child-table-container-second' }, setRender(h, params));
          })
        ]);
      } else {
        return h('p', { class: 'child-table-temp-container' }, '-');
      }
    };

    const isEditTableRow = !editFieldTypeList?.includes(el.fieldType) && el.type != 0 && ((entity.value >= 200 && el.fieldKey != 'chargePerson') || (entity.value < 200 && !editEntityList[entity.value]?.includes(el.fieldKey))) && !contractFieldKey.includes(el.fieldKey);
    const getColType = {
      title: (h, { col }) => <ly-col-more col={col} fieldName={el.fieldName} findAssociation={findAssociation} ruleForm={data.ruleForm} viewId={data.viewId} colOverlayId={data.colOverlayId} showColOverlay={data.showColOverlay} getSearchDataCb={getSearchData} sortCb={sortChange} cb={colTitleFrozen} showLayCb={showLay} setting={item} isSubForm={true} />,
      colKey: `${item.fieldKey}.${el.fieldKey}`,
      type: el.type,
      ellipsisTitle: { theme: 'light' },
      ellipsis: isEditTableRow || [3, 5, 12, 25].includes(el.fieldType) || (item.type == 0 && el.fieldType == 5) ? undefined : { theme: 'default' },
      id: el.id,
      stopPropagation: [12, 25].includes(el.fieldType) ? true : false,
      fieldName: el.fieldName,
      fieldType: el.fieldType,
      setting: item?.fieldVos?.length ? getSubFormField(item.fieldVos) : null,
      fieldExt: el.fieldExt,
      width: tools.getStrLen(item.fieldName) <= 6 ? 180 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 23,
      cell: childRender,
      className: item?.fieldVos?.length == 1 ? 'sub-form-table-list sub-form-table-border-left sub-form-table-border-right' : index == 0 ? 'sub-form-table-list sub-form-table-border-left' : index == item?.fieldVos?.length - 1 ? 'sub-form-table-list sub-form-table-border-right' : 'sub-form-table-list'
    };
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  const fieldList = data.fieldList;
  fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item);
    if (item?.fieldType == 27) {
      //子表单
      const childCols = createChildColumns(item);
      colConfig.children = childCols;
    }
    list.push(colConfig);
  });
  // colType: false,代表不参与排序的列
  if (buttonBatch.value?.length) {
    // list.unshift(createRowSelectColumn());
  }
  if (operationItem.value) {
    list.push(createOperationColumn());
  }
  // list.unshift(createRowComputedColumn());
  console.log(createRowComputedColumn, createRowSelectColumn);
  list.unshift(customOperationColumn());
  return list;
};
const getSubFormField = (fieldVos) => {
  return fieldVos?.map((v) => {
    return {
      fieldKey: v.fieldKey,
      entityId: v.entityId,
      id: v.id,
      fieldType: v.fieldType
    };
  });
};

// 给子组件调用
// const addFieldsSortFun = () => {
//   addFieldsSort(data.fieldList, fieldsSort.value);
// };

// 追加排序字段
const addFieldsSort = (fieldList, fieldsSort) => {
  if (fieldList?.length && fieldsSort?.length) {
    fieldList?.forEach((item) => {
      const obj = fieldsSort?.find((e) => {
        return e.fieldKey == item.fieldKey;
      });
      if (obj) {
        if (obj.fieldSort === true || obj.fieldSort === false) {
          item.fieldSort = obj.fieldSort;
        } else {
          item.fieldSort = '';
        }
      } else {
        item.fieldSort = '';
      }
    });
  }
  // 当没有排序字段时  清空 fieldList 里的 fieldSort
  if (fieldsSort?.length == 0) {
    fieldList?.forEach((item) => (item.fieldSort = ''));
  }
};

// 排序   sort.isDefault == true  恢复默认  sort.isNull == true  清空所有
const sortChange = async (sort = null) => {
  console.log('sortChange', 222);
  addFieldsSort(data.fieldList, fieldsSort.value);
  // 默认排序
  if (typeof sort === 'object' && sort !== null) {
    if (sort.isDefault == true) {
      filterParams.value.sortSettings = useFilterList?.fieldsSortDefault?.length ? useFilterList?.fieldsSortDefault : [];
    }
    if (sort.isNull == true) {
      filterParams.value.sortSettings = [];
    }
  } else {
    // 自定义排序
    filterParams.value.sortSettings = useFilterList?.fieldsSort?.length ? useFilterList?.fieldsSort : [];
  }
  // 过滤掉 停用字段
  if (filterParams.value.sortSettings && filterParams.value.sortSettings?.length) {
    filterParams.value.sortSettings = filterParams.value.sortSettings?.filter((item) => item.fieldStatus != 2);
    // 添加 sort 与 fieldSort
    filterParams.value.sortSettings = JSON.parse(JSON.stringify(filterParams.value))?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      delete item.fieldSort;
      return item;
    });
  }
  selectTableIds.value = [];
  if (data.ruleForm.conditions.length == 0) {
    await groupStructure();
    await getDataList(filterParams.value);
  } else {
    setLoadListParams(filterParams.value);
    await groupStructure();
    await getDataList(filterParams.value);
  }
};
// 标题冻结列
const colTitleFrozen = (key, value, newColumns) => {
  // 创建一个新的数组，避免直接修改原始数据
  const updatedColumns = newColumns?.map((item) => ({ ...item }));
  console.log(834, key, value, newColumns, updatedColumns, 'updatedColumns');
  // 分别筛选出左固定、右固定和非固定的列
  const fixedLeft = updatedColumns?.filter((item) => item.fixed === 'left' && item.colKey !== key);
  const fixedRight = updatedColumns?.filter((item) => item.fixed === 'right' && item.colKey !== key);
  const noFixed = updatedColumns?.filter((item) => !item.fixed && item.colKey !== key);
  // 找到当前列
  const current = updatedColumns?.find((item) => item.colKey === key);
  // 根据 value 来设置当前列的 fixed 属性
  if (value) {
    current.fixed = 'left';
    fixedLeft.push(current); // 将当前列放入左固定数组
  } else {
    current.fixed = undefined;
    noFixed.unshift(current); // 将当前列放入非固定数组的开头
  }
  // 组合新的列数组，确保顺序为左固定 -> 非固定 -> 右固定
  const newList = [...fixedLeft, ...noFixed, ...fixedRight];
  // 假设 fhTableRef.value.getCols(newList) 可以正确处理顺序问题
  fhTableRef.value?.forEach((item) => {
    item.getCols(newList);
  });
  // fhTableRef.value.getCols(newList);
  // console.log(847, newList);
};
// 遮罩层
const showLay = (val, key) => {
  console.log('点击遮罩层', val, key);
  data.showColOverlay = val;
  if (!key) return;
  data.colOverlayId = key;
};
//重置刷新列表
const resetSelected = async () => {
  ids.value = [];
  selectTableIds.value = [];
  console.log('groupDataInit', 2);
  groupDataInit();
  data.checkedDataAll = false;
  data.indeterminate = false;
};

// 快捷组件中按钮的回调
const shortcutBtnCb = async (params, groupKey = null) => {
  if (params?.type === 'refreshRow') {
    selectTableIds.value = selectTableIds.value.filter((v) => v !== params.id);
  }
  if (groupKey) {
    setLoadListParams(arrLL[groupKey + 'params']);
    tProps.value.pagination.pageSize = data.groupPageSize * arrLL[groupKey + 'Page'];
    // data.loading = true;
    await loadTList(1, true);
    // data.loading = false;
    // 强刷数据
    arrLL[groupKey] = {};
    nextTick(() => {
      arrLL[groupKey] = { ...tProps.value, data: tProps.value.data };
    });
  }
  refreshList();
};
// 列表高度监听
watch(
  () => windowHeight.value,
  (v) => {
    const reduceHeight = userInfo?.roles?.indexOf(entity.value >= 200 ? 'object:custom' : 'object:system') !== -1 ? 235 : 195;
    listScroll.value = v - 300 > 200 ? v - reduceHeight : 300;
  },
  {
    deep: true,
    immediate: true
  }
);
//适配自定义对象，添加detailKey的监听zl2024年02月18日16:40:44
watch(
  () => [operationItem.value, detailKey(entity.value)],
  async () => {
    data.columns = getColumns();
  }
);

watch(
  () => data.viewId,
  () => {
    selectTableIds.value = [];
    const params = {
      viewId: data.viewId,
      filterParams: filterParams.value,
      pagination: tProps.value.pagination
    };
    scopeLimit.value = tools.getCookie(scopeKey);
    highSearch.value = scopeLimit.value ? Number(scopeLimit.value) : 0;
    // emits('cb', { type: 2, params });
    universalButtonParams.value = params;
  },
  {
    deep: true,
    immediate: true
  }
);

let timer;
const setScrollXy = (e, groupItem) => {
  // 设置X
  fhTableRef.value?.forEach((item) => {
    var tableBody = item.$el.querySelector('.t-table__content');
    if (tableBody) {
      // 追加150的偏移量让内部列表滚动到最右
      if (e.target.scrollWidth - e.target.scrollLeft === e.target.clientWidth) {
        tableBody.scrollLeft = e.target.scrollLeft + 200;
      } else {
        tableBody.scrollLeft = e.target.scrollLeft;
      }
    }
  });
  if (timer) clearTimeout(timer);
  timer = setTimeout(async () => {
    // 设置Y
    if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight || e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight + 1) {
      if (arrLL[groupItem.groupKey + 'Page'] * data.groupPageSize < arrLL[groupItem.groupKey]?.pagination?.total) {
        arrLL[groupItem.groupKey + 'Page'] = arrLL[groupItem.groupKey + 'Page'] + 1;
        setLoadListParams(arrLL[groupItem.groupKey + 'params']);
        tProps.value.pagination.pageSize = data.groupPageSize * arrLL[groupItem.groupKey + 'Page'];
      }
    }
  }, 700);
};

const handleScroll = (event, groupItem) => {
  const { e } = event;
  setScrollXy(e, groupItem);
};

const setTableTrWidth = async () => {
  nextTick(() => {
    const table = document.getElementsByClassName('fhTable');
    if (table[0]) {
      const firstCell = table[0].querySelector('table thead');
      const firstColgroup = table[0].querySelector('table colgroup col:first-child');
      if (fieldGroups.value?.length == 3) {
        if (!setTableTrWidthStatus.value) {
          setTableTrWidthStatus.value = true;
          firstColgroup?.classList?.add('new-class3');
        }
      }
      if (fieldGroups.value?.length == 2) {
        if (!setTableTrWidthStatus.value) {
          setTableTrWidthStatus.value = true;
          firstColgroup?.classList?.add('new-class2');
        }
      }
      if (fieldGroups.value?.length == 1) {
        if (!setTableTrWidthStatus.value) {
          setTableTrWidthStatus.value = true;
          firstColgroup?.classList?.add('new-class1');
        }
      }
      if (firstCell?.offsetHeight) {
        dynamicStyle.value.top = firstCell?.offsetHeight / 2 - 8 + 'px';
      }
      dynamicStyle.value.display = 'block';
    }
  });
};

// 全选-反选
const checkboxCk = () => {
  data.checkedAll = !data.checkedAll;
  if (data.checkedAll) {
    selectTableIds.value = data.idsAll;
    data.indeterminate = false;
  } else {
    selectTableIds.value = [];
  }
};
const refreshLoading = ref(false);
const refreshList = async (tp) => {
  if (tp === 'detail') {
    // emits('cb', { type: 3 });
  } else {
    clearRowKeys();
    selectTableIds.value = [];
    refreshLoading.value = true;
    await groupDataInit();
    refreshLoading.value = false;
  }
};
const getLoadTableList = async function () {
  if (useLayout?.changeViewId?.[data?.entity]) {
    setLoadListParams({
      id: useLayout?.changeViewId?.[data?.entity]
    });
    data.viewId = useLayout?.changeViewId?.[data?.entity];
    selectTableIds.value = [];
    getField();
  }
  console.log('groupDataInit', 3);
  groupDataInit();
};
const fristInit = ref(false);
const groupInit = async (viewId) => {
  showColOverlayNum.value = showColOverlayNum.value + 1;
  if (fristInit.value) {
    console.log('groupDataInit', 4);
    groupDataInit();
  } else {
    await getField(viewId);
    fristInit.value = true;
  }
};

const eventListen = () => {
  windowHeight.value = window.innerHeight;
};
//监听事件
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
eventListener('resize', eventListen);
onMounted(async () => {
  windowHeight.value = window.innerHeight;

  // 获取筛选条件
  await useFilterList.getConditionsList({ entity: entity.value, apiIndex: Math.random() });
  data.ruleForm.conditions = useFilterList?.conditionsList;

  // 如果不支持筛选则传递默认参数
  //特殊情况：：： 如果是线索池需要先调用接口拿线索池ID的默认线索池id，赋值给scope
  if (!props.isFilter) {
    // entity和id必须有一个必填（id为视图ID）
    setLoadListParams({ conditions: [], entity: entity.value, scope: '0' });
    // data.loading = true;
    await loadTList(1);
    // data.loading = false;
  }

  const res = await setService.getEntitySettings({ entity: entity.value, apiIndex: Math.random() }); //查询entity所有字段
  data.ruleForm.leadsFieldList = res.result;
  data.ruleForm.leadsFieldList
    ?.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18))
    ?.forEach((item) => {
      if (item.fieldType === 10) {
        item.fieldExt = item.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      } else if (item?.business?.fieldType == 10) {
        item.business.fieldExt = item.business?.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      }
      data.ruleForm.objList[item.fieldKey] = item;
    });
  try {
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    if (!json.error) {
      json.result?.forEach((item) => {
        if (item.fieldType === 24) {
          data.ruleForm.filterType[item.fieldType] = item.computeMaps; //第二个框
        } else {
          data.ruleForm.filterType[item.fieldType] = item.conditions; //第二个框
        }
      });
      if (props.parentEntityId) {
        data.qccID.push(findAssociation);
      }
    }
  } catch (e) {
    console.log(e);
  }
  //缓存本次更新的entityId
  data.lastEntityId = entity.value;
  console.log('groupStructure', 4);
  await groupDataInit();
});
// 公共按钮组件事件回调
const universalRefreshList = () => {
  getLoadTableList(undefined, false);
};

// 校验是否全部 展开
const checkAllExpand = computed(() => checkAllStatus(true));
// 校验是否全部收起
const checkAllCollapse = computed(() => checkAllStatus(false));

// 校验是否全部展开 || 校验是否全部收起
const checkAllStatus = (checkExpand = true) => {
  let status = checkExpand;
  if (arrLL.group && arrLL.group.length) {
    for (let a = 0; a < arrLL.group.length; a++) {
      const i = arrLL.group[a];
      if ((checkExpand && i.isShow === false) || (!checkExpand && i.isShow === true)) {
        status = !checkExpand;
        break;
      }
      if (i.groups && i.groups.length > 0) {
        for (let b = 0; b < i.groups.length; b++) {
          const ii = i.groups[b];
          if ((checkExpand && ii.isShow === false) || (!checkExpand && ii.isShow === true)) {
            status = !checkExpand;
            break;
          }
          if (ii.groups && ii.groups.length > 0) {
            for (let c = 0; c < ii.groups.length; c++) {
              const iii = ii.groups[c];
              if ((checkExpand && iii.isShow === false) || (!checkExpand && iii.isShow === true)) {
                status = !checkExpand;
                break;
              }
            }
          }
        }
      }
    }
  }
  return status;
};

// // 校验是否全部 展开
// const checkAllExpand = computed(() => {
//   let status = true;
//   if (arrLL.group && arrLL.group?.length) {
//     if (arrLL.group) {
//       for (let a = 0; a < arrLL.group.length; a++) {
//         const i = arrLL.group[a];
//         if (i.isShow == false) {
//           status = false;
//         }
//         if (i.groups && i.groups.length > 0) {
//           for (let b = 0; b < i.groups.length; b++) {
//             const ii = i.groups[b];
//             if (ii.isShow == false) {
//               status = false;
//             }
//             if (ii.groups && ii.groups.length > 0) {
//               for (let c = 0; c < ii.groups.length; c++) {
//                 const iii = ii.groups[c];
//                 if (iii.isShow == false) {
//                   status = false;
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }
//   return status;
// });
// // 校验是否全部收起
// const checkAllCollapse = computed(() => {
//   let status = false;
//   if (arrLL.group && arrLL.group?.length) {
//     if (arrLL.group) {
//       for (let a = 0; a < arrLL.group.length; a++) {
//         const i = arrLL.group[a];
//         if (i.isShow == true) {
//           status = true;
//         }
//         if (i.groups && i.groups.length > 0) {
//           for (let b = 0; b < i.groups.length; b++) {
//             const ii = i.groups[b];
//             if (ii.isShow == true) {
//               status = true;
//             }
//             if (ii.groups && ii.groups.length > 0) {
//               for (let c = 0; c < ii.groups.length; c++) {
//                 const iii = ii.groups[c];
//                 if (iii.isShow == true) {
//                   status = true;
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }
//   return status;
// });

// 一键收起 && 一键展开
const oneTouchExpand = (type = null) => {
  if (type == false) {
    const elements = document.querySelectorAll('[data-groupKey]');
    divElements.value = [];
    elements.forEach((element) => {
      divElements.value.push(element.getAttribute('data-groupKey'));
    });
    console.log('elements', elements);
  }
  if (arrLL.group && arrLL.group.length) {
    for (let a = 0; a < arrLL.group.length; a++) {
      const i = arrLL.group[a];
      i.isShow = type;
      if (i.groups && i.groups.length > 0) {
        for (let b = 0; b < i.groups.length; b++) {
          const ii = i.groups[b];
          ii.isShow = type;
          if (ii.groups && ii.groups.length > 0) {
            for (let c = 0; c < ii.groups.length; c++) {
              const iii = ii.groups[c];
              iii.isShow = type;
            }
          }
        }
      }
    }
  }
};
// 一键展开
const oneTouchRetract = () => {
  oneTouchExpand(true);
  const elements = document.querySelectorAll('[data-groupKey]');
  console.log('elements', elements);
  elements.forEach((element) => {
    divElements.value.push(element.getAttribute('data-groupKey'));
  });
  if (divElements.value?.length) {
    const difference = divElements.value.filter((item) => !observedIds.has(item));
    if (difference?.length) {
      getRemainingListPage(difference);
    }
  }
};

// 请求剩余listpage
const getRemainingListPage = async (difference) => {
  for (let i = 0; i < difference.length; i++) {
    const groupkey = difference[i];
    if (!observedIds.has(groupkey)) {
      observedIds.add(groupkey);
      publicListPage(groupkey);
    }
  }
};

// 是否有单字段排序
const hasSingleFieldSort = (useFilterList, params) => {
  if (useFilterList?.fieldsSort?.length) {
    params.sortSettings = useFilterList?.fieldsSort?.filter((item) => item.fieldStatus != 2) || [];
    params.sortSettings = JSON.parse(JSON.stringify(params))?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      delete item.fieldSort;
      return item;
    });
  }
  return params;
};
/*************** 规则相关 start ****************/
const updateFieldPermission = async ({ fieldValue, businessId, fieldKey, subFormFieldKey = undefined, subId = undefined }) => {
  try {
    let groupKey = '';
    let dataIndex = '';
    const length = arrLL.fieldKeys?.length;
    for (let i = 0; i < length; i++) {
      const fk = arrLL.fieldKeys[i];
      if (arrLL?.[fk]?.data?.length) {
        const _findIndex = arrLL?.[fk]?.data?.findIndex((fkd) => fkd.id == businessId);
        if (_findIndex > -1) {
          groupKey = fk;
          dataIndex = _findIndex;
          break;
        }
      }
    }
    if (dataIndex == -1) {
      return false;
    }
    const res = await layoutService.fieldPermission({
      type: 'ID',
      value: businessId, //tableData.value?.[dataIndex] || {},
      entity: entity.value,
      source: 4
    });
    if (!res?.error) {
      const agd = arrLL[groupKey].data[dataIndex];
      agd['PERMISSION'] = res?.result?.permissions || {};
      //因为行内编辑是临时显示，表格数据不会变，这里更新一下，不然重渲规则会丢失最新的值
      if (subFormFieldKey) {
        //子表单赋值
        const subIndex = agd[subFormFieldKey]?.findIndex((td) => td?.id == subId);
        agd[subFormFieldKey][subIndex][fieldKey] = fieldValue;
      } else {
        agd[fieldKey] = fieldValue;
      }
    }
  } catch (e) {
    console.log(e);
  }
};
/*************** 规则相关 end ****************/
const publicListPage = async (groupkey) => {
  try {
    const page = arrLL[groupkey + 'Page'];
    const params = { ...arrLL[groupkey + 'params'] };
    params.groupkey = groupkey;
    // 是否有单字段排序
    const updatedParams = hasSingleFieldSort(useFilterList, params);
    setLoadListParams(updatedParams);
    tProps.value.pagination.pageSize = data.groupPageSize;
    const json = await loadTList(page);
    arrLL[groupkey] = JSON.parse(JSON.stringify(tProps.value));
    const ids = arrLL[groupkey].data?.map((mm) => mm.id);
    addParentsIds(arrLL.group, groupkey?.replace('index', ''), ids);
    // 整理全部ID
    arrLL.group?.forEach((item) => {
      data.idsAll = [...new Set([...data.idsAll, ...item.ids])];
    });
    checkGroupAllData(arrLL.group);
    checkAllData();
    if (!json.error && json.result?.current) {
      // 当前页小于总分页
      if (arrLL[groupkey + 'Page'] < json.result?.pages) {
        arrLL[groupkey + 'Page'] = json.result?.current + 1;
      }
    }
  } catch (e) {
    console.log(e);
  }
};
// 分组的回调
const hasGroup = (params) => {
  emits('cbGroup', params);
};
const seeTarget = _.debounce(async () => {
  if (data.countAll > 500) return;
  const targets = document.querySelectorAll('.group-tag');
  const options = {
    root: null,
    rootMargin: '0px',
    // 3层 0.5
    threshold: 0
  };
  if (props.fieldGroups && props.fieldGroups?.length) {
    if (props.fieldGroups?.length == 1) options.threshold = 0.1;
    if (props.fieldGroups?.length == 3) options.threshold = 0.5;
  }
  // 回调函数
  const callback = async (entries) => {
    console.log('callback');
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const groupkey = entry.target.getAttribute('data-groupKey');
      if (entry.isIntersecting) {
        if (!observedIds.has(groupkey)) {
          observedIds.add(groupkey);
          publicListPage(groupkey);
        }
      } else {
        // console.log('entry-out',entry.target.textContent + ' is out of the viewport.');
      }
    }
  };

  const observer = new IntersectionObserver(callback, options);
  // 开始观察每个目标元素
  targets.forEach((target) => observer.observe(target));
}, 0);

// 监听排序字段
watch(
  () => useFilterList?.fieldsSort,
  (v) => {
    fieldsSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);

provide('defaultParams', {
  id: computed(() => data.id),
  entity: computed(() => entity.value),
  tab: computed(() => data.tab),
  viewId: computed(() => data.viewId),
  account_id: computed(() => data.account_id),
  input_rbKcJb: computed(() => data.bingDataInput_rbKcJb),
  poolId: computed(() => poolId.value),
  columns: computed(() => data.columns),
  fieldFilterList: computed(() => fieldFilterList.value),
  dataPermission: computed(() => data.dataPermission)
});

// provide('listSort', {
//   sortChange: computed(() => sortChange),
//   addFieldsSortFun: computed(() => addFieldsSortFun)
// });

defineExpose({ searchInit, getField, loadTList, toDetails, getLoadTableList, groupInit });
</script>
<style scoped lang="less">
@import './ly-list-group-layout.less';
</style>
